import React, { useState, useEffect, Suspense } from 'react';
import ModulCheckout from './components/Checkout/ModulCheckout';
import ModulCheckoutControl from './components/CheckoutControl/ModulCheckoutControl';
import store from './redux/checkoutredux/store/checkoutStore.ts';   //Todo-ips änderung ts js

import { setAllCheckoutContext,  setCheckoutContextInitial, setPaymentMethod } from './redux/checkoutredux/actions/checkoutactions/checkoutActions';
import { setSidecartSettings, setCheckoutSettings, setGeneralSettings} from './redux/checkoutredux/actions/settingsactions/settingsActions';

import { setAllCartData } from './redux/checkoutredux/actions/cartactions/fetchdirectActions';
//import { setMetaCartData } from './redux/checkoutredux/actions/cartactions/metacartActions';
//import { setNoticeData} from './redux/checkoutredux/actions/cartactions/noticeActions';
//import { setProductData} from './redux/checkoutredux/actions/cartactions/productdataActions';





function AppCheckout() {


  const [checkoutsettings, setSettings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const baseURL = window.location.origin;

  console.log("<><> APP_Checkout START <><>");

  console.log("STORE:")
  console.log("Store 1: ",store);
  console.log("Store state: ",store.getState());
  





/* ************************************************************************************************************/
/* **********************       Sidecart Function Fetch Options       *****************************************/




  
  useEffect(() => {

    //console.log("Aktuelles Verzeichnis:", window.location.href);
    
    async function fetchData() {

    //++++++++++++++++++++++++++++++++++++++++++++++++ SIDECART ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const cartSettings = window.appSettings;                                //? APP_Settings - SIDECART


    //++++++++++++++++++++++++++++++++++++++++   BOTH SIDECART & CHECKOUT  +++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const generalData = window.ipsGeneralData;                             //? Both - SIDECART & CHECKOUT    currency, shoppingcart
    const checkouthooks = window.ipsGeneralData.checkouthooks;
    


    //++++++++++++++++++++++++++++++++++++++++++++++++ CHDECKOUT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    //const currency = window.appCheckoutSettings.currency;                   
    //const pickupSettings = window.appCheckoutSettings.checkoutcontext.checkoutcontextinitial.localpickupoptions;       //? APP_CheckoutSettings - Checkout
    //const paymentMethods = window.appCheckoutSettings.checkoutcontext.checkoutcontextinitial.paymentmethods;
    const checkoutsettings = window.appCheckoutSettings.checkoutsettings;
    const checkoutcontext = window.appCheckoutSettings.checkoutcontext;

    console.log("Checkoutcontext: ",checkoutcontext);   //paymentmethods, localpickup, adressdata_woo, user_info_login


    





   // const checkoutContext = paymentMethods, pickupSettings

    //const appCheckoutSettings = window.appCheckoutSettings;
 
    //const shippingMethods = window.appCheckoutSettings.shippingmethods;

    //const expresspaymentMethods = window.appCheckoutSettings.expresspaymentmethods;



    //Sidecart | CartData

    
  

    if (cartSettings) {
      console.log("SAVE CARTSETTINGS Checkout: ",cartSettings);
     // setIsLoading(false);
      //setLocations(pickupSettings);
      store.dispatch(setSidecartSettings(cartSettings)); // Daten an den Redux-Store übergeben
    } else {
      console.log('setCartSettingsData is not defined or null');
    }

    if (generalData) {
      //console.log("SAVE General Data: ",generalData);
     // setIsLoading(false);
      //setLocations(pickupSettings);
      store.dispatch(setAllCartData(generalData.currentshoppingcart.data));
      store.dispatch(setGeneralSettings(generalData.generalData));
/*
      store.dispatch(setMetaCartData(cartData.currentshoppingcart.data.metacartdata)); 
      store.dispatch(setNoticeData(cartData.currentshoppingcart.data.noticedata));
      store.dispatch(setProductData(cartData.currentshoppingcart.data.productdata));

      */
    } else {
      console.log('generalData is not defined or null');
    }



      //console.log("Checkout Set: ",appCheckoutSettings);
      //console.log("Pickup Set: ",pickupSettings);

   /* if (pickupSettings) {
      setIsLoading(false);
      //setLocations(pickupSettings);
      store.dispatch(setPickupLocations(pickupSettings)); // Daten an den Redux-Store übergeben
    } else {
      console.log('pickupSettings is not defined or null');
    }*/

    /*
    if (shippingMethods) {
      setIsLoading(false);
      //setLocations(pickupSettings);
      store.dispatch(setDeliveryMethod(shippingMethods)); // Daten an den Redux-Store übergeben
    } else {
      console.log('shippingmethods is not defined or null');
    }
*/


  /*  if (expresspaymentMethods) {
      //setIsLoading(false);
      //setLocations(pickupSettings);
      //store.dispatch(setPaymentMethod(paymentMethods)); // Daten an den Redux-Store übergeben
      console.log('expresspaymentmethods ...: ',expresspaymentMethods);
    } else {
      console.log('expresspaymentmethods is not defined or null');
    }
      */


    if (checkoutcontext) {
      setIsLoading(false);
      //setLocations(pickupSettings);
     // store.dispatch(setCheckoutContext(checkoutcontext)); // Daten an den Redux-Store übergeben
     //store.dispatch(setAllCheckoutContext(checkoutcontext)); // Daten an den Redux-Store übergeben
     store.dispatch(setCheckoutContextInitial(checkoutcontext.checkoutcontextinitial));   //Paymentmethods, woo Billing and Shipping addressdata, ...
    } else {
      console.log('checkoutcontext is not defined or null');
    }


/*    if (paymentMethods) {
      setIsLoading(false);
      //setLocations(pickupSettings);
      store.dispatch(setPaymentMethod(paymentMethods)); // Daten an den Redux-Store übergeben
    } else {
      console.log('paymentmethods is not defined or null');
    }*/

    if (checkoutsettings) {
      setIsLoading(false);
      //setLocations(pickupSettings);
      store.dispatch(setCheckoutSettings(checkoutsettings)); // Daten an den Redux-Store übergeben
      setSettings(checkoutsettings);
    } else {
      console.log('checkoutsettings is not defined or null');
    }

    /*
    if (checkouthooks) {
      setIsLoading(false);
      //setLocations(pickupSettings);
      store.dispatch(setGeneralSettings(checkouthooks)); // Daten an den Redux-Store übergeben
    } else {
      console.log('checkouthooks is not defined or null');
    }
      */

    /*if (appCheckoutSettings) {
   
      
     
      console.log("App Checkout Settings currency: ",appCheckoutSettings.currency);
      setIsLoading(false);
      setSettings(appCheckoutSettings);
      
    
      
     
    } else {
      console.log('appCheckoutSettings is not defined or null');
    }
      */
  }


    fetchData();
   

  }, []);




  /*
  useEffect(() => {
    if (settings) {
     
    } else {

    }
  }, [settings]);

*/


  
   
  return (
    <div>
      <Suspense fallback={<p>Loading...</p>}>
      {/*!isLoading && settings && <ModulNavbar toggleSidebar={toggleSidebar} />*/}
      {/*!isLoading && settings && <ModulCheckoutControl settings={settings} />*/}
      {!isLoading && checkoutsettings && <ModulCheckout store={store} />}

      </Suspense>
      {/* Ladeanzeige anzeigen, während Daten geladen werden */}
      {isLoading && <p>Loading...</p>}


    </div>
  );
}

export default AppCheckout;